import { render, staticRenderFns } from "./bannerScroll.vue?vue&type=template&id=f4867432&scoped=true"
import script from "./bannerScroll.vue?vue&type=script&lang=js"
export * from "./bannerScroll.vue?vue&type=script&lang=js"
import style0 from "./bannerScroll.vue?vue&type=style&index=0&id=f4867432&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4867432",
  null
  
)

export default component.exports